export const calcPercent = (num: number, total: number) => {
  if (total === 0) return 0;
  return ((num / total) * 100).toFixed(2);
};

export const safeDivide = (numerator: number, denominator: number): number => {
  return denominator === 0 ? 0 : numerator / denominator;
};
